import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { NgbActiveModal, NgbAccordionItem } from '@ng-bootstrap/ng-bootstrap';
import { GoogleMapsService } from '../../google-maps/google-maps.service';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DeliveryLocationOverrideService } from '../../delivery-location-override/delivery-location-override.service';

@Component({
  selector: 'app-create-delivery-location-override-modal',
  standalone: true,
  imports: [NgbAccordionItem, ReactiveFormsModule],
  templateUrl: './create-delivery-location-override-modal.component.html',
  styleUrl: './create-delivery-location-override-modal.component.scss'
})
export class CreateDeliveryLocationOverrideModalComponent implements OnInit {

  @Input()
  headerLabel: string = 'Location';

  @Input()
  latitude: number | null = null;

  @Input()
  longitude: number | null = null;

  @Input()
  addressName: string = '';

  @Input()
  addressDetails: string = '';

  @Input()
  masterContactId: number | null = null;

  @ViewChild('deliveryLocationMap') locationMap!: any;

  invalidCoordinates: boolean = false;
  newLocationName: string = '';

  formGroup: FormGroup = new FormGroup({});

  constructor(protected activeModal: NgbActiveModal, private googleMapsService: GoogleMapsService, private fb: FormBuilder, private deliveryLocationOverrideService: DeliveryLocationOverrideService) { }

  ngOnInit(): void {
    this.formGroup = this.fb.group({
      newLocationName: this.fb.control(''),
      latitude: this.fb.control(this.latitude),
      longitude: this.fb.control(this.longitude)
    });

    this.displayGoogleMap(this.latitude, this.longitude);
  }

  saveLocation() {
    if (this.formGroup) {
      const newLocationData = {
        name: this.formGroup.get('newLocationName')?.value || this.addressName,
        latitude: this.formGroup.get('latitude')?.value,
        longitude: this.formGroup.get('longitude')?.value,
        address: this.addressDetails,
        associatedMasterContactId: this.masterContactId,
        deliveryLocationOverrideId: null
      };

      this.deliveryLocationOverrideService.createDeliveryLocationOverride(newLocationData).subscribe({
        next: (result: any) => {
          (newLocationData.deliveryLocationOverrideId as any) = result.deliveryLocationOverrideId;

          this.activeModal.close({ status: 'success', deliveryLocationOverrideData: newLocationData });
        },
        error: (error: any) => {
          console.error("Error creating delivery location override:", error);
          this.activeModal.close({ status: 'error', error });
        }
      });
    }
  }

  locationStateInvalid() {
    return this.formGroup.get('newLocationName')?.value.length === 0;
  }

  getLatitude() {
    return this.formGroup?.get('latitude')?.value;
  }

  getLongitude() {
    return this.formGroup?.get('longitude')?.value;
  }

  async displayGoogleMap(lat: number | null, lng: number | null) {
    if (lat === null || lng === null || isNaN(lat) || isNaN(lng) || lat < -90 || lat > 90 || lng < -180 || lng > 180
      || (lat === 0 && lng === 0)) {
      this.invalidCoordinates = true;
      return;
    }

    const loader = this.googleMapsService.getLoader();
    try {
      setTimeout(async () => {
        const { Map } = await loader.importLibrary('maps') as google.maps.MapsLibrary;
        const { AdvancedMarkerElement } = await loader.importLibrary('marker');

        const mapElement = this.locationMap.nativeElement as HTMLElement;
        if (!mapElement) {
          console.error("Map element not found");
          return;
        }

        // Create the map
        const map = new Map(mapElement, {
          center: { lat: lat, lng: lng },
          zoom: 16,
          mapId: "delivery-location-map"
        });

        // Create the marker
        const marker = new AdvancedMarkerElement({
          map,
          position: { lat: lat, lng: lng },
          gmpDraggable: true
        });

        marker.addListener('dragend', (event: any) => {
          const newPosition = event.latLng;

          if (newPosition) {
            this.formGroup?.get('latitude')?.setValue(newPosition.lat().toFixed(6));
            this.formGroup?.get('longitude')?.setValue(newPosition.lng().toFixed(6));
          }
        });
      }, 100);
    } catch (error) {
      console.error("Error loading Google Maps libraries or displaying map:", error);
    }
  }
}
